import { connect } from 'react-redux';

import { CallRecords } from './call-records/call-records.component';
import { downloadCdr, downloadCdrALeg, getRecords } from '../../../redux/actions/records';
import {
  selectCurrentLocationId,
  selectCurrentLocationSlug,
} from '../../../redux/actions/location/current-location';

export const CallRecordsContainer = connect(
  (state: any) => ({
    isNextPageAvailable: state.records.isNextPageAvailable,
    loading: state.records.loading,
    locationId: selectCurrentLocationId(state),
    records: state.records.records,
    slug: selectCurrentLocationSlug(state),
  }),
  (dispatch) => ({
    getRecords: (searchTerm, start, end, limit, skip, status) => {
      dispatch(getRecords({ searchTerm, start, end, limit, skip, status }));
    },
    downloadCDR: (channelId) => {
      dispatch(downloadCdr(channelId));
    },
    downloadCDRALeg: (channelId) => {
      dispatch(downloadCdrALeg(channelId));
    },
  })
)(CallRecords);
